import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Input, Select, DatePicker, Radio, Checkbox, Collapse, notification, Divider, InputNumber } from 'antd';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Tabs } from 'antd';
import { EnvironmentOutlined, AuditOutlined, HomeOutlined, FileProtectOutlined, DollarCircleOutlined } from '@ant-design/icons';


import { RecordFormWrapper } from './Style';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { Button } from '../../../components/buttons/buttons';
import { Main, BasicFormWrapper } from '../../styled';
import { productoCreateAction, productoReadAction } from '../../../redux/administracion/productos/actionCreator';


const dateFormat = 'YYYY-MM-DD';

const ProductoMainForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  
  const registro = useSelector(state => state.ProductoReducer.record);
  const isLoading = useSelector(state => state.responseReducer.loading);
  const { id } = useParams();
  const [form] = Form.useForm();


  useEffect(() => {
    if (id)
      dispatch(productoReadAction(id));
    else {
      dispatch(productoReadAction());
      form.resetFields();
    }
  }, [id]);

  useEffect(() => {
    if (registro.id) {      
      form.setFieldsValue(registro);
    } else {
      form.resetFields();
    }
  }, [form, registro]);

  const handleSubmit = async (values) => {
    let action = 'create';
    if (id) {
      action = 'update';
    }

    const responseApi = await dispatch(productoCreateAction({
      ...values,
      action: action
    }));
    if (responseApi) {
      let mensaje = 'Producto creado exitosamente';
      if (action === "update") mensaje = 'Producto actualizado exitosamente';
      notification.success({
        message: mensaje,
      });
      form.resetFields();
      history.replace('/admin/productos/listado');
    } else {
      notification.error({
        message: 'Error al gestionar producto',
      });
    }
  };

  return (
    <>
      <PageHeader
        buttons={[
          <Button className="btn-add_new" size="default" key="1" type="primary">
            <Link to="/admin/productos/listado">Ver todos</Link>
          </Button>,
        ]}
        ghost
        title="FICHA DEL PRODUCTO"
      />
      <Main>
        <Row gutter={15}>
          <Col xs={24}>
            <Form
              className="add-record-form"
              style={{ width: '100%' }}
              layout="horizontal"
              size="small"
              form={form}
              name="addnew"
              onFinish={handleSubmit}
            >
              <RecordFormWrapper>
                <Cards headless>
                  <BasicFormWrapper>
                    <Form.Item name="id" initialValue="0">
                      <Input hidden />
                    </Form.Item>
                    <Form.Item name="nombre" label="Nombre del producto" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Input placeholder="Ej. Pasta dental" />
                    </Form.Item>
                    <Form.Item name="descripcion" label="Descripción">
                      <Input.TextArea placeholder="Ej. Tubo 100 ml" />
                    </Form.Item>                    
                  </BasicFormWrapper>

                  <br />
                  <div className="record-form-actions text-right">
                    <Button size="default" htmlType="Save" type="primary">
                      {isLoading ? 'Cargando...' : 'Guardar'}
                    </Button>
                  </div>
                </Cards>
              </RecordFormWrapper>
            </Form>
          </Col>
        </Row>
      </Main>
    </>
  );
};

export default ProductoMainForm;
